import React from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { ActionsContent } from "./ActionsContent";
import { GetEstadoBadge } from "../utils/EstadosBadge";
import Badge from "../../../../../../../Utils/Badge/Badge";

export const PaletizacionesTable = ({
    paletizaciones,
    EliminarPaletizacion,
    paletizacionCerrada,
}) => {
    return (
        <div
            className="new-table-wrapper paletizaciones__table-wrapper mx-auto"
            style={{ marginBottom: "2rem" }}
        >
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Hora</th>
                        <th>Cant. Pallets</th>
                        <th>Cant. Pacas</th>
                        <th>Pacas turno actual</th>
                        <th>Pacas turno anterior</th>
                        <th>Pacas en reclasificación</th>
                        <th>Estado</th>
                        <th>Kg hule seco</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {paletizaciones.length === 0 && (
                        <tr>
                            <td colSpan={9} className="text-center">
                                No hay registros de paletizaciones
                            </td>
                        </tr>
                    )}
                    {paletizaciones.map((item) => {
                        const estadoBadge = GetEstadoBadge(item.estado);

                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap">
                                    {item.fecha_con_desfase
                                        ? moment(item.fecha_con_desfase).format(
                                              "HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pallets} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pacas} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas_turno_actual}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas_turno_anterior}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas_reclasificacion}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <Badge
                                        variant={estadoBadge.variant}
                                        text={estadoBadge.text}
                                    />
                                </td>

                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.total_peso}
                                        decimals={2}
                                    />
                                </td>
                                <td>
                                    <ActionsContent
                                        item={item}
                                        EliminarPaletizacion={
                                            EliminarPaletizacion
                                        }
                                        paletizacionCerrada={
                                            paletizacionCerrada
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
